import { render, staticRenderFns } from "./ViewRevocationRecords.vue?vue&type=template&id=a8e132ac&scoped=true"
import script from "./ViewRevocationRecords.vue?vue&type=script&lang=js"
export * from "./ViewRevocationRecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8e132ac",
  null
  
)

export default component.exports